import React from 'react';

import Instagram from 'images/icon/instagram.inline.svg';
import Facebook from 'images/icon/facebook.inline.svg';
import Spotify from 'images/icon/spotify.inline.svg';
import styles from './index.css';

const SocialMedia = () => (
	<div className={styles.socialMedia}>
		<a target="_blank" href="https://www.instagram.com/9floor.co/" rel="noopener noreferrer">
			<Instagram />
		</a>
		<a target="_blank" href="https://www.facebook.com/9floor.co/" rel="noopener noreferrer">
			<Facebook />
		</a>
		<a
			target="_blank"
			href="https://open.spotify.com/user/cmas3ut0ye02tk1q56qwkf3pu?si=1MWz3EIzQYyVmYMd2CbmbQ"
			rel="noopener noreferrer"
		>
			<Spotify />
		</a>
	</div>
);

export default SocialMedia;



// WEBPACK FOOTER //
// ./src/components/atoms/SocialMedia/index.js